import React from "react";
import { Form, Select } from "antd";
import PropTypes from "prop-types";

const SelectInput = ({
  form,
  rules = [],
  label,
  options = [],
  name,
  onChange,
  inputProps,
}) => {
  const [isRequired, setIsRequired] = React.useState(false);

  React.useEffect(() => {
    if (rules && rules.length && !isRequired) {
      setIsRequired(rules.find((item) => item.required === true));
    }
  }, [rules, isRequired]);

  const handlerChange = (value) => {
    onChange && onChange(value);
  };

  return (
    <Form.Item
      key={name}
      label={label}
      required={isRequired}
      name={name}
      rules={rules}
    >
      <Select onChange={handlerChange} placeholder={label} {...inputProps}>
        {options.map((option) => {
          if (React.isValidElement(option)) {
            return option;
          }

          return (
            <Select.Option {...option.props} value={option.value}>
              {option.text}
            </Select.Option>
          );
        })}
      </Select>
    </Form.Item>
  );
};

SelectInput.propTypes = {
  rules: PropTypes.array,
  label: PropTypes.string,
  options: PropTypes.array,
  name: PropTypes.string,
  onChange: PropTypes.func,
  inputProps: PropTypes.any,
};

export default SelectInput;
